var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cordel-filters-form"},[_c('form-sections',{attrs:{"schema":_vm.schema,"buttonless":""},on:{"change":_vm.input,"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }